import { Pipe, PipeTransform } from '@angular/core';
import { WorkshopJobWorkStatus } from '../../models/workshop-job';

@Pipe({
    name: 'workshopJobStatusLabel',
    standalone: true
})
export class WorkshopJobStatusLabelPipe implements PipeTransform {
  private statusLabels: Map<WorkshopJobWorkStatus, string> = new Map([
    ['booked_in', 'Booked in'],
    ['assessed', 'Assessed'],
    ['quotation', 'Quotation'],
    ['quote_approved', 'Quote approved'],
    ['waiting_for_parts', 'Waiting for parts'],
    ['repair_started', 'Repair started'],
    ['completed', 'Completed'],
    ['cancelled', 'Cancelled']
  ]);

  transform(value: string): string {
    if (value === 'all') {
      return 'All';
    }
    if (value === 'in_progress') {
      return 'In progress';
    }
    if (value === 'closed') {
      return 'Closed';
    }
    if (this.statusLabels.has(value as WorkshopJobWorkStatus)) {
      return this.statusLabels.get(value as WorkshopJobWorkStatus);
    }
    return value;
  }
}
